module.exports = __webpack_public_path__ + "static/img/bg2.5fdb37e.png";